import React from 'react'

interface Props {
  title: string
  children: React.ReactNode
  sectionRef?: React.RefObject<HTMLDivElement>
  id?: string
}

export function SectionCard({ title, children, sectionRef, id }: Props) {
  return (
    <div id={id} ref={sectionRef} className="bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-800 overflow-hidden mb-6">
      <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-800">
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white">{title}</h2>
      </div>
      <div className="p-6">{children}</div>
    </div>
  )
}
